/* eslint-disable linebreak-style */
import isBrowser from 'utils/isBrowser';
import isEnableGtag from 'utils/isEnableGtag';
import { event } from 'utils/withGA';

// to see the metrics on the debug console,
// you need to add the parameter webvitals_debug=true
// in the url
const enableWebVitalsDebug = () => {
  if (isBrowser()) {
    const query = window.location.search;
    if (query.includes('webvitals_debug=true')) {
      sessionStorage.setItem('webvitals_debug', 1);
    } else if (query.includes('webvitals_debug') || query.includes('webvitals_debug=false')) {
      sessionStorage.removeItem('webvitals_debug');
    }
  }
};

export default function metrics({ id, name, label, value }) {
  enableWebVitalsDebug();
  if (isBrowser() && isEnableGtag()) {
    if (sessionStorage.getItem('webvitals_debug')) {
      // eslint-disable-next-line no-console
      console.log('[ Web Vitals ]', { id, name, label, value });
    }
    event({
      action: name,
      category: label === 'web-vital' ? 'Web Vitals' : 'Next.js custom metric',
      label: id,
      value: Math.round(name === 'CLS' ? value * 1000 : value),
      nonInteraction: true
    });
  }
}
